<template>
  <card class="wrapper" v-if="billPeriodNum && billPeriodNum > 0">
    <AdminTitle title="账单明细" size="15px" bottom="5px"/>

    <div class="wrapper-period special-card">
      <div class="item">
        <el-checkbox-group>
          <el-checkbox
            v-for="item in billPeriodNum"
            :key="item"
            :label="item"
            disabled
          >
            第{{ item }}期：￥{{ eachRentPrice }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
  </card>
</template>

<script>

export default {
  name: 'PeriodMallInfo',
  props: ['billPeriodNum', 'eachRentPrice' ]
}
</script>

<style lang="scss" scoped>
.wrapper ::v-deep {
  width: 100%;
  border-color: transparent;
  margin-top: 5px;
  border-radius: 16px;
  color: #222222;

  .wrapper-period {
    border-radius: 16px;
    padding: 15px;
  }

  .special-card {
    background: #f7f8fa;
    line-height: 35px;
    border-radius: 16px;
  }

  .bill-deposit {
    color: #ee0a24;
    font-size: 12px;
  }

  .el-checkbox__input.is-disabled + span.el-checkbox__label {
    color: #222222;
  }

  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    border-color: #dcdfe6;
  }

  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    border-color: #409eff;
  }
}
</style>
